// extracted by mini-css-extract-plugin
export var brand = "_9l-9";
export var compact = "_9l-6";
export var extraSmall = "_9l-7";
export var icon = "_9l-0";
export var large = "_9l-4";
export var light = "_9l-1";
export var medium = "_9l-5";
export var outline = "_9l-b";
export var primaryDark = "_9l-a";
export var primaryLight = "_9l-8";
export var primaryModern = "_9l-c";
export var success = "_9l-2";
export var successSolid = "_9l-3";